import { Input } from 'antd';

import { FormItemField } from '../../FormItemField';
import { useSnils } from '../hooks';

interface SnilsInputInterface {
  fieldName: string | number | (string | number)[];
  label: string;
  disabled?: boolean;
  required?: boolean;
  validateStatus?: 'success' | 'warning' | 'error' | 'validating';
  isStrongTitle?: boolean;
}

export const SnilsInput = ({
  fieldName,
  label,
  disabled,
  required,
  validateStatus,
  isStrongTitle = true,
}: SnilsInputInterface) => {
  const { formatSnils, getSnilsDigits, validateSnils } = useSnils();

  return (
    <FormItemField
      label={label}
      fieldName={fieldName}
      required={required}
      validateStatus={validateStatus}
      getValueFromEvent={(e) => getSnilsDigits(e.target.value)}
      isStrongTitle={isStrongTitle}
      getValueProps={(value) => ({
        value: formatSnils(value ?? ''),
      })}
      rules={[
        {
          validator: (_, value: string) => {
            if (!required && !value) {
              return Promise.resolve();
            }

            const error = validateSnils(value);
            return error ? Promise.reject(new Error(error)) : Promise.resolve();
          },
        },
      ]}
    >
      <Input size="large" placeholder="___-___-___ __" disabled={disabled} />
    </FormItemField>
  );
};
